import React from 'react';
import {
  Box,
  Heading,
  Text,
  Badge,
  Flex,
  HStack,
  VStack,
} from '@chakra-ui/react';
import VariantPaymentTimeline from './VariantPaymentTimeline';
import CheckoutBugNoticeText from './CheckoutBugNoticeText';

function fallbackSociFromVarianti(summary) {
  const grouped = (summary.varianti || []).reduce((bySocio, line) => {
    const existing = bySocio[line.socioId];
    if (!existing) {
      return {
        ...bySocio,
        [line.socioId]: {
          socioId: line.socioId,
          socioName: line.socioName,
          mvpAttivo: false,
          residuoTotale: 0,
          varianti: [line],
        },
      };
    }

    return {
      ...bySocio,
      [line.socioId]: {
        ...existing,
        varianti: [...existing.varianti, line],
      },
    };
  }, {});

  return Object.values(grouped);
}

const EventPaymentSummaryPanel = ({
  summaries = [],
  onFocusOrder,
  onPaySaldo,
  onPayPending,
}) => {
  if (!summaries?.length) {
    return null;
  }

  const handleStepPay = (line, step) => {
    if (step.type === 'saldo') {
      onPaySaldo?.({
        productId: line.variantId,
        socioId: line.socioId,
        amount: line.accontoPaid,
        applyDiscount: line.applyDiscount,
        initialEventPrice: line.initialEventPrice,
      });
      return;
    }

    if (step.type === 'totale') {
      onPayPending?.(line.orderId);
      return;
    }

    if (step.type === 'acconto') {
      onFocusOrder?.(line.orderId);
    }
  };

  const hasCheckoutBugNotice = summaries.some((summary) => summary.bugLikely);

  return (
    <VStack align="stretch" spacing={4} mb={6}>
      <Box>
        <Heading size="md" color="white" fontWeight="700">
          Pagamenti da completare
        </Heading>
        <Text fontSize="sm" color="gray.400" mt={1}>
          Per ogni settimana vedi acconto e saldo. Clicca la barra arancione per
          pagare.
        </Text>
      </Box>

      {hasCheckoutBugNotice && <CheckoutBugNoticeText />}

      {summaries.map((summary) => (
        <Box
          key={summary.eventId}
          bg="#36393f"
          borderRadius="12px"
          border="1px solid"
          borderColor={summary.bugLikely ? 'orange.500' : 'gray.600'}
          p={{ base: 4, md: 5 }}
        >
          <Flex
            justify="space-between"
            align="flex-start"
            flexWrap="wrap"
            gap={3}
            mb={4}
          >
            <Box>
              <Heading size="sm" color="white">
                {summary.eventName}
              </Heading>
              <HStack mt={2} spacing={2} flexWrap="wrap">
                {summary.bugLikely && (
                  <Badge colorScheme="orange">Verifica pagamento</Badge>
                )}
              </HStack>
            </Box>
          </Flex>

          <VStack align="stretch" spacing={5}>
            {(summary.soci?.length
              ? summary.soci
              : fallbackSociFromVarianti(summary)
            ).map((socio) => (
              <Box key={socio.socioId}>
                <Flex
                  justify="space-between"
                  align="center"
                  flexWrap="wrap"
                  gap={2}
                  mb={3}
                >
                  <Heading size="xs" color="gray.200">
                    {socio.socioName || 'Partecipante'}
                  </Heading>
                  {socio.mvpAttivo && (
                    <Badge colorScheme="purple">Prezzo MVP</Badge>
                  )}
                </Flex>

                <VStack align="stretch" spacing={3}>
                  {socio.varianti?.map((line) => (
                    <VariantPaymentTimeline
                      key={`${socio.socioId}-${line.variantId}`}
                      line={line}
                      onStepPay={handleStepPay}
                      hideSocioName
                    />
                  ))}
                </VStack>
              </Box>
            ))}
          </VStack>
        </Box>
      ))}
    </VStack>
  );
};

export default EventPaymentSummaryPanel;
